import { gql } from '@apollo/client'

import { CHAT_CUSTOMER_FRAGMENT } from 'Const'

export const SIGN_UP = gql`
  mutation SignUpCustomer($input: SignUpCustomerInput!) {
    signUpCustomer(input: $input) {
      customer {
        ...ChatCustomer
      }
      state
    }
  }
  ${CHAT_CUSTOMER_FRAGMENT}
`
